import { useLocation } from 'react-router-dom'
import RoutesConfig from './routes'
import Navbar from './components/Navbar'
import SessionTimeoutModal from './components/SessionTimeoutModal'
import RouteErrorBoundary from './components/RouteErrorBoundary'

export default function App() {
  const location = useLocation()

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1 py-6 sm:py-8">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6">
          <RouteErrorBoundary key={location.pathname}>
            <RoutesConfig />
          </RouteErrorBoundary>
        </div>
      </main>
      <SessionTimeoutModal />
    </div>
  )
}
